import type { DigestRunSummary, DigestSendResponse, DigestSettings } from '@testflow/shared';
import { request } from './api.js';

const base = (p: string) => `/v1/projects/${p}`;

export const digestApi = {
  getSettings(projectId: string): Promise<DigestSettings> {
    return request<DigestSettings>(`${base(projectId)}/digest/settings`);
  },
  putSettings(projectId: string, settings: DigestSettings): Promise<DigestSettings> {
    return request<DigestSettings>(`${base(projectId)}/digest/settings`, {
      method: 'PUT',
      body: JSON.stringify(settings),
    });
  },
  history(projectId: string): Promise<DigestRunSummary[]> {
    return request<DigestRunSummary[]>(`${base(projectId)}/digest/history`);
  },
  historyHtml(projectId: string, runId: string): Promise<{ html: string }> {
    return request<{ html: string }>(`${base(projectId)}/digest/history/${runId}`);
  },
  preview(projectId: string, planId: string): Promise<{ html: string }> {
    return request<{ html: string }>(`${base(projectId)}/digest/preview?test_plan_id=${planId}`);
  },
  // #160: Der Server antwortet, sobald der Lauf gestartet ist — das Ergebnis des Versands steht
  // danach in der Historie (`history`) unter `digest_run_id`.
  send(projectId: string): Promise<DigestSendResponse> {
    return request<DigestSendResponse>(`${base(projectId)}/digest/send`, { method: 'POST' });
  },
};
